import { render, staticRenderFns } from "./UpdateTodosDialog.vue?vue&type=template&id=180f3218&scoped=true"
import script from "./UpdateTodosDialog.vue?vue&type=script&lang=js"
export * from "./UpdateTodosDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateTodosDialog.vue?vue&type=style&index=0&id=180f3218&prod&scoped=true&lang=css"
import style1 from "./UpdateTodosDialog.vue?vue&type=style&index=1&id=180f3218&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f3218",
  null
  
)

export default component.exports